import { ref } from 'vue'

const showInvalidTokenDialog = ref(false)
const errorType = ref('invalid_token')

export const useInvalidTokenDialog = () => {
	const showDialog = (type = 'invalid_token') => {
		errorType.value = type
		showInvalidTokenDialog.value = true
	}

	const hideDialog = () => {
		showInvalidTokenDialog.value = false
		errorType.value = 'invalid_token'
	}

	const onClosed = () => {
		hideDialog()
	}

	const onRequestNewLink = () => {
		hideDialog()
	}

	return {
		showInvalidTokenDialog,
		errorType,
		showDialog,
		hideDialog,
		onClosed,
		onRequestNewLink
	}
}